import PropTypes from 'prop-types'
import React from 'react'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import { PlanBillingChangePlanForm } from './PlanBillingChangePlanForm'

function PlanBillingChangePlanDialog(props) {
  const {
    isOpen,
    onClose,
    onSubmit,
    initialValue = {},
    paymentMethod = undefined,
    planBill,
  } = props
  if (!isOpen) return null

  return (
    <ResponsiveDialog
      open={isOpen}
      scroll="paper"
      fullWidth
      maxWidth="lg"
      aria-labelledby="scroll-dialog-title"
    >
      <PlanBillingChangePlanForm
        initialValue={initialValue}
        paymentMethod={paymentMethod}
        onClose={onClose}
        onSubmit={onSubmit}
        planBill={planBill}
      />
    </ResponsiveDialog>
  )
}

PlanBillingChangePlanDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  paymentMethod: PropTypes.object,
  initialValue: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    company: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    countryCode: PropTypes.string,
    streetAddress: PropTypes.string,
  }),
}

export default PlanBillingChangePlanDialog
